// extracted by mini-css-extract-plugin
export default {"root":"TableImage_root__TIIpn"};